import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext.ts";
import { useEffect, useContext } from "react";
import { USER_TYPE } from "constants/constants.js";
import toast from "react-hot-toast";
// import AuthContext from "./AuthenticationContext.ts";

import useAxios from "../../services/useAxios.tsx";
// import sendRequest from "hooks/useAxios";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  tokenTest?: string;
  fullName: string;
  fname: string;
  lname: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: number[];
  id: any;
  isFirst: boolean;
}

export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const { execute: checkLoginInfoApi } = useAxios("api/checklogininfo");
  const { execute: getTokenTest } = useAxios("api/generate_token_test");

  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    fname: "",
    lname: "",
    tokenTest: "",
    userType: -1,
    mobile: 0,
    userName: "",
    accessLevel: [],
    id: null,
    isFirst: true,
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [isChecked, setisChecked] = useState<boolean>(false);

  function login(
    token: string,
    fullName: string,
    fname: string,
    lname: string,
    userType: number,
    mobile: number,
    userName: string,
    accessLevel: any[],
    id: any
  ): void {
    console.log("tokenCheck: ", token);
    if (token) {
      // if (userType == 1) {
      //   accessLevel = [13, 14, 15, 16];
      // }
      setUserInfo({
        token,
        fullName,
        fname,
        lname,
        userType: userType,
        mobile,
        userName,
        accessLevel,
        id: id,
        isFirst: false,
      });

      setIsLogged(true);
      Cookies.set("token", token, { expires: 7 });
    }
  }

  function logout(): void {
    setUserInfo((prev) => ({
      ...prev,
      token: "",
      fullName: "",
      userType: -1,
      mobile: 0,
      userName: "",
      accessLevel: [],
      id: null,
      isFirst: false,
    }));
    setIsLogged(false);
    Cookies.remove("token");
  }
  const tokenTest = () => {
    console.log("checkLoginInfoApi check cookie get token test");

    getTokenTest({ uid: "-1" }).then(({ token }) => {
      console.log("checkLoginInfoApi check cookie get token test api");

      if (token) {
        console.log("ok set testtoken");
        Cookies.set("testToken", token);
        setUserInfo((prev) => ({ ...prev, tokenTest: token }));
        setisChecked(true);
      }
    });
  };
  function checkCookie(): void {
    if (Cookies.get("token")) {
      console.log("xxxx");
      console.log("checkLoginInfoApi check cookie token");

      checkLoginInfoApi().then((data) => {
        if (data.status == -1) {
          toast.error("کاربری با این مشخصات یافت نشد.");
          Cookies.remove("token");
          return "";
        }
        let userType;
        login(
          data.data.usertoken,
          data.userinfo[0].fname + " " + data.userinfo[0].lname,
          data.userinfo[0].fname,
          data.userinfo[0].lname,
          +data.userinfo[0].type,
          data.userinfo[0].mobile,
          "",
          [],
          +data.userinfo[0].id
        );
        setisChecked(true);
      });
    } else {
      //shFazeli 1402/04/26 start
      if (Cookies.get("testToken")) {
        setUserInfo((prev) => ({
          ...prev,
          tokenTest: Cookies.get("testToken"),
        }));
        setisChecked(true);
        return;
      } else {
        tokenTest();
        console.log("check token test");
      }

      //shFazeli 1402/04/26 end
      // setUserInfo({
      //   token: "",
      //   fullName: "",
      //   userType: -1,
      //   mobile: 0,
      //   userName: "",
      //   accessLevel: [],
      //   id: null,
      //   isFirst: false,
      // });//shFazeli 1402/04/28
    }
  }

  useEffect(() => {
    if (isLogged) return;
    checkCookie(); //shFazeli 1402/04/26
  }, [isLogged]);

  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          isChecked,
          logout,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
// "ba68d1382a58515cba89dd9d07552625##2##1689587113"
